import { LargeCard } from "@/pages/dashboard/stats/subs/LargeCard";
import { FinancialWrapper } from "../../style";
import {
  getHeadOfHospitalTableData,
  getHeadOfPharmacyTableData,
  getRequestDetailsData,
  headOfHospitalTableHeaders,
  headOfHospitalTableKeys,
  headOfPharmacyTableHeaders,
  headOfPharmacyTableKeys,
  hospitalHeadFinancialCards,
  newFundRequestForm,
} from "../data";
import { Button } from "@/common/components/button";
import { Modal } from "@/common/components/modal";
import Form from "@/common/components/form/Form";
import { useCallback, useMemo, useState } from "react";
import Table from "@/common/components/Table";
import useQuery from "@/hooks/useQuery";
import { DELIVERY_REQUEST_URLS } from "@/common/constants";
import { KeyValueObj } from "@/common/types";
import { Pagination } from "@/common/components/pagination";
import Tab2 from "@/common/components/Tab/Tab2";
import RequetDetails from "./requetDetails";

const HospitalHeadFinancial = () => {
  const [newRequestModal, setNewRequestModal] = useState(false);
  const [requestDetailsModal, setRequestDetailsModal] = useState(false);
  const [currentTab, setCurrentTab] = useState("Head of Pharmacy Request");
  const [headOfPharmacyPerpage, setHeadOfPharmacyPerpage] = useState(10);
  const [headOfhospitalPerpage, setHeadOfHospitalPerpage] = useState(10);
  const [showDropdown, setShowDropdown] = useState(false);
  const [currentRow, setCurrentRow] = useState<KeyValueObj>({});
  const handleNewFundSubmit = () => {
    alert("submit requested -->");
  };

  const {
    data: headOfPharmacyData,
    meta: headOfPharmacyMeta,
    loading: headOfPharmacyLoading,
  } = useQuery(
    DELIVERY_REQUEST_URLS +
      `/incoming-requests?per_page=${headOfPharmacyPerpage}&page=${headOfPharmacyPerpage}`
  );

  const {
    data: headOfHospitalData,
    meta: headOfHospitalMeta,
    loading: headOfHospitalLoading,
  } = useQuery(
    DELIVERY_REQUEST_URLS +
      `/incoming-requests?per_page=${headOfhospitalPerpage}&page=${headOfhospitalPerpage}`
  );

  const handleHeadOfPharmacyDropdownClick = useCallback(
    (row: KeyValueObj) => {
      const willShow = !showDropdown;
      const newRow = willShow ? row : {};

      setCurrentRow(newRow);
      setShowDropdown(willShow);
    },
    [showDropdown]
  );

  const handleHeadOfHospitalDropdownClick = useCallback(
    (row: KeyValueObj) => {
      const willShow = !showDropdown;
      const newRow = willShow ? row : {};

      setCurrentRow(newRow);
      setShowDropdown(willShow);
    },
    [showDropdown]
  );

  const handleHeadOfPharmacyView = useCallback(() => {
    setRequestDetailsModal(true);
  }, []);

  const handleHeadOfHospitalView = useCallback(() => {
    alert("coming soon");
  }, []);

  const headOfPharmacyDropdownOptions = useMemo(
    () =>
      currentRow?.trackingID?.value !== "--"
        ? [{ label: "View", action: handleHeadOfPharmacyView }]
        : [{ label: "View", action: handleHeadOfPharmacyView }],
    [handleHeadOfPharmacyView, currentRow]
  );

  const headOfHospitalDropdownOptions = useMemo(
    () =>
      currentRow?.trackingID?.value !== "--"
        ? [{ label: "View", action: handleHeadOfHospitalView }]
        : [{ label: "View", action: handleHeadOfHospitalView }],
    [handleHeadOfHospitalView, currentRow]
  );

  const tabs = [
    {
      title: "Head of Pharmacy Request",
      component: (
        <div className="table-wrapper">
          <Table
            tableHeaders={headOfPharmacyTableHeaders}
            tableKeys={headOfPharmacyTableKeys}
            tableData={getHeadOfPharmacyTableData(headOfPharmacyData)}
            tableTitle="Head of Pharmacy Request"
            tableSubtitle={
              (headOfPharmacyMeta?.total_count ?? "0") + " Requests"
            }
            loading={headOfPharmacyLoading}
            handleDropDownClicked={handleHeadOfPharmacyDropdownClick}
            showDropDown={showDropdown}
            dropDownOptions={headOfPharmacyDropdownOptions}
            spaced
            rowLineColor="light"
          />
          <Pagination
            pageCount={headOfPharmacyMeta?.total_pages}
            onNextPage={(event: any) =>
              setHeadOfPharmacyPerpage(event.selected)
            }
            onPerPageChange={(event: any) =>
              setHeadOfPharmacyPerpage(event?.target?.value)
            }
          />
        </div>
      ),
    },
    {
      title: "Head of Hospital Request",
      component: (
        <div className="table-wrapper">
          <Table
            tableHeaders={headOfHospitalTableHeaders}
            tableKeys={headOfHospitalTableKeys}
            tableData={getHeadOfHospitalTableData(headOfHospitalData)}
            tableTitle="Head of Hospital Request"
            loading={headOfHospitalLoading}
            handleDropDownClicked={handleHeadOfHospitalDropdownClick}
            showDropDown={showDropdown}
            dropDownOptions={headOfHospitalDropdownOptions}
            spaced
            rowLineColor="light"
          />
          <Pagination
            pageCount={headOfHospitalMeta?.total_pages}
            onNextPage={(event: any) =>
              setHeadOfHospitalPerpage(event.selected)
            }
            onPerPageChange={(event: any) =>
              setHeadOfHospitalPerpage(event?.target?.value)
            }
          />
        </div>
      ),
    },
  ];

  return (
    <FinancialWrapper>
      <div className="card-wrapper">
        {hospitalHeadFinancialCards?.map((card: any) => (
          <LargeCard
            color={card?.color}
            icon={card.icon}
            value={card.value}
            title={card.name}
          />
        ))}
      </div>
      <div>
        <div className="top-wrapper">
          <Button onClick={() => setNewRequestModal(true)}>
            New Fund Request
          </Button>
        </div>
      </div>
      <Tab2
        onTabClick={(tab: string) => setCurrentTab(tab)}
        currentTab={currentTab}
        tabs={tabs}
      />
      <Modal
        title="New Fund Request"
        isOpen={newRequestModal}
        close={() => setNewRequestModal(false)}
      >
        <div className="modal">
          <Form
            formInputs={newFundRequestForm}
            processInputs={handleNewFundSubmit}
          />
        </div>
      </Modal>

      <Modal
        title="Request Details"
        isOpen={requestDetailsModal}
        close={() => setRequestDetailsModal(false)}
      >
        <div className="modal">
          {/* <Form
            formInputs={newFundRequestForm}
            processInputs={handleNewFundSubmit}
          /> */}
          <RequetDetails data={getRequestDetailsData(currentRow) as any} />
        </div>
      </Modal>
    </FinancialWrapper>
  );
};

export default HospitalHeadFinancial;
